import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';
import { gql } from '@apollo/client';
import { apolloClient as client } from "../data-provider/graphqlDataProvider";
export async function CreateBundle(data: any) {
    const CREATE_BUNDLE = gql`
    mutation CreateBundle($data: ProductCreateInput!){
        createProduct(data: $data) {
        id
        }
    }
  `;

    return await client.mutate({
        mutation: CREATE_BUNDLE,
        variables: {
            data: data
        }
    }).then((res) => {
        console.log('res in CreateBundle: ', res)
        return res
    }).catch((err) => {
        console.log('err in CreateBundle: ', err)
        throw err
    })
}
export async function getProducts() {
    const GET_Products = gql`
        query Products($where: ProductWhereInput) {
            products(where: $where) {
                id
                title
                subtitle
                subtitle2
                description
                price
                offValue
                productType
                meta
                expiryPeriod
                service
                isEnabled
                images
            }
        }
    `;

    try {
        const response = await client.query({
            query: GET_Products,
            variables: {
                where: {
                    service: { equals: process.env.REACT_APP_SERVICE },
                    isEnabled: { equals: true }
                },
            },
        });

        return response.data.products;
    } catch (error) {
        console.error("Error fetching products:", error);
        return []; // Return an empty array in case of error
    }
}
export async function createRule(params: any, id: any) {


    try {
        const { data } = await client.mutate({
            mutation: gql`
                mutation CreateRule($data: RuleCreateInput!) {
                    createRule(data: $data) { 
                        id
                    }
                }
            `,
            variables: {
                data: {
                    ...params,
                    product: {
                        connect: {
                            id: id
                        }
                    }
                }
            }
        });
        return data;
    } catch (error) {
        console.error('GraphQL error:', error);
        throw new Error('fail');
    }
}
export async function rulesPatch(param: any) {
    console.log("rulesPatch param", param);

    const data = {
        isEnabled: param.rulesEnabled,
    };

    const config = {
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
    };

    return axiosWithAuthInterceptor.patch(
        `${process.env.REACT_APP_LEMONADE_SERVER}/api/rules/${param.id}`,
        data,
        config
    ).then(res => {
        return res;
    });
}